import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { AlertCircle, TrendingUp, Gauge } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

/**
 * Component for rendering an empty state for RiskAlerts
 */
export const RiskAlertsEmptyState = () => (
  <Card className="h-full">
    <CardHeader>
      <CardTitle className="text-lg">Risk Alerts</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="flex flex-col justify-center p-6 h-[220px] text-center border border-dashed border-gray-200 rounded-lg bg-gray-50">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
          <AlertCircle className="h-6 w-6 text-blue-500" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No Risk Alerts</h3>
        <p className="text-sm text-gray-500 mb-4 max-w-xs mx-auto">
          Create and deploy trading strategies to receive risk monitoring alerts
        </p>
      </div>
    </CardContent>
  </Card>
);

/**
 * Component for rendering an empty state for TradingActivity
 */
export const TradingActivityEmptyState = () => (
  <Card className="h-full">
    <CardHeader>
      <CardTitle className="text-lg">Trading Activity</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="flex flex-col justify-center p-6 h-[220px] text-center border border-dashed border-gray-200 rounded-lg bg-gray-50">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
          <TrendingUp className="h-6 w-6 text-blue-500" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No Trading Activity</h3>
        <p className="text-sm text-gray-500 mb-4 max-w-xs mx-auto">
          Create and activate strategies to see your trading activity
        </p>
        <Button 
          variant="outline" 
          className="mx-auto w-auto"
        >
          <span>Learn About Trading</span>
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </CardContent>
  </Card>
);

/**
 * Component for rendering an empty state for ActivePositions
 */
export const ActivePositionsEmptyState = () => (
  <div className="col-span-3 lg:col-span-2">
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="text-lg">Active Positions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col justify-center p-6 h-[220px] text-center border border-dashed border-gray-200 rounded-lg bg-gray-50">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50">
            <Gauge className="h-6 w-6 text-blue-500" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No Active Positions</h3>
          <p className="text-sm text-gray-500 mb-4 max-w-xs mx-auto">
            Create a trading strategy to generate positions
          </p>
          <Button 
            variant="outline" 
            className="mx-auto w-auto"
          >
            <span>Learn About Positions</span>
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
);
